export const getEditInboundOriginAddressPayload = address => {
  const payload = {
    sender_address: {
      ...address,
      country: address?.country?.code,
      phone: address?.phone,
      province: address?.province?.code,
    },
  }

  delete payload.sender_address?.customer

  return payload
}
